import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { enumEntrySummaryState, enumEntrySummarySubmissionType } from '@data-layer/enums/entry-summaries';
import { enumPaymentState } from '@data-layer/enums/payments';
import { EntrySummaryStatusHelper } from '@helpers/entry-summary-status.helper';
import { CustomStateModel } from '@data-layer/models/common';
import { CustomState } from '@data-layer/enums/common';
import { ApplicationModeService } from '@services/application-mode.service';
import { enumApplicationMode } from '@enum/enumApplicationMode';

@Component({
  selector: 'es-status',
  templateUrl: './es-status.component.html',
  styleUrls: ['./es-status.component.scss'],
})
export class EsStatusComponent implements OnChanges {
  @Input() public submissionType: enumEntrySummarySubmissionType;
  @Input() public state: enumEntrySummaryState;
  @Input() public customStateHeader: string;
  @Input() public customState: CustomStateModel<CustomState>;
  @Input() public paymentState: enumPaymentState;
  @Input() public showSecondTextForDeleted: boolean = false;

  public firstText: string = null;
  public secondText: string = null;
  public hintText: string = null;
  public hintTextColor: string = null;
  public firstTextColor: string = null;
  public secondTextColor: string = null;
  public pointColor: string = null;

  constructor(private applicationModeService: ApplicationModeService) {}

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.state || changes.paymentState || changes.submissionType) {
      const state: enumEntrySummaryState = EntrySummaryStatusHelper.resolveDisplayState(
        this.state,
        this.applicationModeService.activeApplicationMode === enumApplicationMode.USER,
      );
      this.firstText = EntrySummaryStatusHelper.getFirstText(
        state,
        this.paymentState,
        this.submissionType,
        this.customStateHeader,
        this.customState,
      );
      this.firstTextColor = EntrySummaryStatusHelper.getFirstTextColor(state, this.paymentState);
      this.secondText = EntrySummaryStatusHelper.getSecondText(state);
      this.secondTextColor = EntrySummaryStatusHelper.getSecondTextColor(state);
      this.hintText = EntrySummaryStatusHelper.getHintText(state, this.paymentState, this.showSecondTextForDeleted);
      this.hintTextColor = EntrySummaryStatusHelper.getHintTextColor(state);
      this.pointColor = EntrySummaryStatusHelper.getPointColor(state, this.paymentState);
    }
  }
}
